<div class="wrap">
  <div class="logoWrapper">
    <img src="/assets/img/logo_CoudPouce.png" alt="">
  </div>
  <div class="login-card">
    <p>Connexion à votre compte</p>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="formField">
        <mat-icon color="primary">
          account_box
        </mat-icon>
        <mat-form-field appearance="outline">
          <mat-label>
            {{'auth.login.username.label' | translate}}
          </mat-label>
          <input type="text" matInput formControlName="username">
          <mat-error>{{'auth.login.username.errorMessage' | translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="formField">
        <mat-icon color="primary">
          lock
        </mat-icon>
        <mat-form-field appearance="outline">
          <mat-label>
            {{'auth.login.password.label' | translate}}</mat-label>
          <input type="password" matInput formControlName="password">
          <mat-hint align="end"><a routerLink="/login/forgot-password">{{'auth.forgotPassword' | translate}}</a>
          </mat-hint>
          <mat-error>{{'auth.login.password.errorMessage' | translate}}</mat-error>
        </mat-form-field>
      </div>


      <button type="submit" mat-raised-button color="primary" *ngIf="!isLoading" [disabled]="loginForm.invalid">Se
        connecter</button>
      <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
    </form>
  </div>
